import { render, staticRenderFns } from "./access-email.vue?vue&type=template&id=e3b74bac&scoped=true"
import script from "./access-email.vue?vue&type=script&lang=js"
export * from "./access-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b74bac",
  null
  
)

export default component.exports